import * as React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem,
  CommandList, CommandSeparator,
} from '@/components/ui/command';
import { Input } from '@/components/ui/input';
import { ChevronsUpDown } from 'lucide-react';
import { MAJOR_CITIES } from '@/data/cities';

// Searchable city picker with an explicit「其他」option that reveals a free-text input.
export default function CityPicker({ value, onChange, testId = 'region-input' }) {
  const [open, setOpen] = React.useState(false);
  const [custom, setCustom] = React.useState(false);

  const pickCity = (city) => { setCustom(false); onChange(city); setOpen(false); };
  const pickOther = () => { setCustom(true); onChange(''); setOpen(false); };

  const label = custom ? '其他（自行輸入）' : (value || '搜尋或選擇城市');

  return (
    <div className="space-y-2">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="flex h-10 w-full items-center justify-between rounded-sm border border-[#E5E0D8] bg-white px-3 text-sm"
            data-testid={testId}
          >
            <span className={value || custom ? 'text-[#1A1A1A]' : 'text-[#9A9A9A]'}>{label}</span>
            <ChevronsUpDown className="h-4 w-4 opacity-50" strokeWidth={1.5} />
          </button>
        </PopoverTrigger>
        <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)]" align="start">
          <Command>
            <CommandInput placeholder="搜尋城市…" />
            <CommandList>
              <CommandEmpty>
                <button type="button" onClick={pickOther} className="text-sm text-[#C93B2B] underline">
                  找不到？選擇「其他」自行輸入
                </button>
              </CommandEmpty>
              <CommandGroup>
                {MAJOR_CITIES.map((c) => (
                  <CommandItem key={c} value={c} onSelect={() => pickCity(c)}>{c}</CommandItem>
                ))}
              </CommandGroup>
              <CommandSeparator />
              <CommandItem value="其他 自行輸入 other" onSelect={pickOther}>✍️ 其他（自行輸入）</CommandItem>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>

      {custom && (
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="請輸入出生城市"
          className="rounded-sm"
          autoComplete="off"
          data-testid={`${testId}-custom`}
        />
      )}
    </div>
  );
}
